import React from 'react'
import { useGenericRequestHandler } from '../../handlers/useGenericRequestHandler'

export const useAccountSAKMutation = () => {
  return useGenericRequestHandler({
    route: 'v1/c/accountSAK',
    method: 'POST'
  })
}
